/* global axios */
import ApiClient from '../ApiClient';

class MaxPersonalClient extends ApiClient {
  constructor() {
    super('max_personal', { accountScoped: true });
  }

  qrStart(sessionId) {
    return axios.post(`${this.url}/qr_start`, { session_id: sessionId });
  }

  qrStatus(sessionId) {
    return axios.get(`${this.url}/qr_status`, {
      params: { session_id: sessionId },
    });
  }

  qrPassword(sessionId, password) {
    return axios.post(`${this.url}/qr_password`, {
      session_id: sessionId,
      password,
    });
  }

  qrComplete(sessionId) {
    return axios.post(`${this.url}/qr_complete`, { session_id: sessionId });
  }
}

export default new MaxPersonalClient();
